const ua = navigator.userAgent;
const isIE =
  ua.indexOf('MSIE ') > 0 &&
  (function () {
    var pos = ua.indexOf('MSIE ');
    return parseInt(ua.substring(pos + 5, ua.indexOf('.', pos)), 10);
  })();

export const IE =
  isIE ||
  (ua.indexOf('Trident/') > 0 &&
    (function () {
      var pos = ua.indexOf('rv:');
      return parseInt(ua.substring(pos + 3, ua.indexOf('.', pos)), 10);
    })());
